import { z } from "zod";

import { MediumSchema } from "api/services/appointment/schemas/shared";

export const BookingFormSchema = z.object({
  date: z.string().min(1),
  start_time: z.number(),
  end_time: z.number(),
  health_care_provider_service_id: z.string().min(1),
  medium: MediumSchema.or(z.literal("")),
  note: z.string().optional(),
  patient_id: z.string().min(1),
  personnel: z.number().optional(),
});

export const BookingFormManagerSchema = z.object({
  ...BookingFormSchema.shape,
  personnel: z.number(),
});

export type BookingFormData = z.infer<typeof BookingFormSchema>;
